import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import RacoonLoading from 'src/components/RacoonLoading';
import { useDecodedToken } from 'src/hooks/useDecodedToken';

const DRAWER_WIDTH = 264;
const COLLAPSED_WIDTH = 100;

const PageTemplate = ({ loading, loadingMessage, children, sx }) => {
  const { isExpert } = useDecodedToken();
  const isCollapsed = useSelector((state) => state.navbar?.isCollapsed) || false;

  const marginTop = isExpert ? { xs: 3, sm: 3 } : { xs: 10, md: 4 };
  const navbarWidth = isCollapsed ? COLLAPSED_WIDTH : DRAWER_WIDTH;

  return (
    <Container
      maxWidth="none"
      sx={{
        maxWidth: { xs: '100vw', md: `calc(100vw - ${navbarWidth}px)` },
        my: 2,
        minHeight: 'calc(100vh - 292px)',
        mt: marginTop,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {loading ? <RacoonLoading message={loadingMessage} /> : children}
    </Container>
  );
};

PageTemplate.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingMessage: PropTypes.string,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default PageTemplate;
